// The backend ObjectMapper registers JavaTimeModule without disabling WRITE_DATES_AS_TIMESTAMPS,
// so LocalDate serialises as [year, month, day], LocalDateTime as
// [year, month, day, hour, minute, second, nano], and OffsetDateTime as fractional epoch seconds.
// These normalise all three at the point a response enters the app, so components and query params
// only ever see ISO-8601 strings. Remove once the mapper emits ISO directly.

const pad = (value) => String(value).padStart(2, "0");

export const toIsoDate = (value) => {
  if (!Array.isArray(value)) {
    return value ?? null;
  }
  const [year, month, day] = value;
  return `${year}-${pad(month)}-${pad(day)}`;
};

export const toIsoDateTime = (value) => {
  if (typeof value !== "number") {
    return value ?? null;
  }
  return new Date(value * 1000).toISOString();
};

// No timezone: a LocalDateTime carries none, so appending one here would invent an offset the
// server never stated. Consumers read it as local time, which is what the admin who wrote it saw.
export const toIsoLocalDateTime = (value) => {
  if (!Array.isArray(value)) {
    return value ?? null;
  }
  const [year, month, day, hour = 0, minute = 0, second = 0] = value;
  return `${year}-${pad(month)}-${pad(day)}T${pad(hour)}:${pad(minute)}:${pad(second)}`;
};
